module.exports = __webpack_public_path__ + "img/flasklogo.d16ffca9.png";